export default __webpack_public_path__ + "static/media/flag-vietnam.c46949a1.svg";